import { createI18n } from 'vue-i18n';
import de from './locales/de.yaml'; // Import the German translations

console.log('Loaded German Translations:', de); // Debugging log


const messages = {
  de,
};

const i18n = createI18n({
  locale: 'de', // Set the default locale to German
  fallbackLocale: 'de',
  messages,
});

export default i18n;
